(function () {
  var STORE_CURRENCY = 'OMR';
  var CURRENCY_KEY = 'cosmeticCurrency';
  var RATES_KEY = 'cosmeticCurrencyRates';
  var RATES_TTL = 12 * 60 * 60 * 1000; // 12h
  var GEO_ENDPOINTS = ['https://ipwho.is/', 'https://ipapi.co/json/'];
  // Fetched in USD so coverage is as wide as possible (every provider supports USD as base);
  // GCC + all other currencies are then derived as a cross rate against the store currency.
  var RATES_ENDPOINT = 'https://open.er-api.com/v6/latest/USD';
  var ROUND_TO = 10; // round converted prices to the nearest 10, no decimals

  // Used only if both IP geolocation endpoints are blocked (ad blockers/privacy extensions).
  var TIMEZONE_CURRENCY = {
    'Asia/Dubai': 'AED',
    'Asia/Riyadh': 'SAR',
    'Asia/Kuwait': 'KWD',
    'Asia/Bahrain': 'BHD',
    'Asia/Qatar': 'QAR',
    'Asia/Muscat': 'OMR',
    'Asia/Baghdad': 'IQD',
    'Asia/Amman': 'JOD',
    'Asia/Beirut': 'LBP',
    'Europe/London': 'GBP',
    'Europe/Paris': 'EUR',
    'Europe/Berlin': 'EUR',
    'Europe/Madrid': 'EUR',
    'Europe/Rome': 'EUR',
    'America/New_York': 'USD',
    'America/Chicago': 'USD',
    'America/Los_Angeles': 'USD',
    'Asia/Kolkata': 'INR',
    'Asia/Karachi': 'PKR',
    'Asia/Dhaka': 'BDT',
    'Asia/Manila': 'PHP',
    'Asia/Singapore': 'SGD',
    'Australia/Sydney': 'AUD',
    'Asia/Tokyo': 'JPY',
  };

  function parseMoney(text) {
    var match = text.replace(/,/g, '').match(/\d+(\.\d+)?/);
    return match ? parseFloat(match[0]) : NaN;
  }

  function formatAmount(amount) {
    var rounded = Math.round(amount / ROUND_TO) * ROUND_TO;
    return rounded.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  function formatMoney(amount, currency) {
    return formatAmount(amount) + ' ' + currency;
  }

  function getForcedCurrency() {
    var params = new URLSearchParams(window.location.search);
    var forced = params.get('forceCurrency');
    return forced ? forced.toUpperCase() : null;
  }

  function timezoneGuess() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return TIMEZONE_CURRENCY[tz] || null;
    } catch (e) {
      return null;
    }
  }

  async function detectCurrency() {
    var forced = getForcedCurrency();
    if (forced) {
      sessionStorage.setItem(CURRENCY_KEY, forced);
      return forced;
    }

    var cached = sessionStorage.getItem(CURRENCY_KEY);
    if (cached) return cached;

    var currency = null;
    for (var i = 0; i < GEO_ENDPOINTS.length; i++) {
      try {
        var res = await fetch(GEO_ENDPOINTS[i], { cache: 'no-store' });
        var data = await res.json();
        var detected = (data.currency && data.currency.code) || data.currency;
        if (detected) {
          currency = String(detected).toUpperCase();
          break;
        }
      } catch (e) {
        // try next endpoint
      }
    }

    if (!currency) currency = timezoneGuess() || STORE_CURRENCY;

    sessionStorage.setItem(CURRENCY_KEY, currency);
    return currency;
  }

  async function getRates() {
    try {
      var cached = JSON.parse(localStorage.getItem(RATES_KEY) || 'null');
      if (cached && Date.now() - cached.ts < RATES_TTL) return cached.rates;
    } catch (e) {}

    var res = await fetch(RATES_ENDPOINT);
    var data = await res.json();
    var rates = data.rates; // USD -> every currency
    try {
      localStorage.setItem(RATES_KEY, JSON.stringify({ ts: Date.now(), rates: rates }));
    } catch (e) {}
    return rates;
  }

  function crossRate(usdRates, targetCurrency) {
    var usdToStore = usdRates[STORE_CURRENCY];
    var usdToTarget = usdRates[targetCurrency];
    if (!usdToStore || !usdToTarget) return null;
    return usdToTarget / usdToStore;
  }

  // Simple leaf elements whose entire text is the amount (native .money spans,
  // and the bespoke carousel/collection-grid "amount" markers).
  function convertLeaf(el, rate, currency, includeCode) {
    var current = el.textContent.trim();
    if (el.dataset.cosmeticLast === current) return;
    var amount = parseMoney(current);
    if (isNaN(amount)) return;
    var out = includeCode ? formatMoney(amount * rate, currency) : formatAmount(amount * rate);
    el.textContent = out;
    el.dataset.cosmeticLast = out;
  }

  // Mixed-content containers where the amount lives in a direct text-node child
  // alongside other elements (e.g. the product page hero price + its currency span).
  function convertTextNodeChild(el, rate, currency) {
    var textNode = null;
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE && !isNaN(parseMoney(node.textContent))) {
        textNode = node;
        break;
      }
    }
    if (!textNode) return;
    var current = textNode.textContent;
    if (el.dataset.cosmeticLast === current) return;
    var amount = parseMoney(current);
    if (isNaN(amount)) return;
    var replaced = current.replace(/\d[\d,]*(\.\d+)?/, formatAmount(amount * rate));
    textNode.textContent = replaced;
    el.dataset.cosmeticLast = replaced;
  }

  function updateCodeLabel(el, currency) {
    if (el.dataset.cosmeticLast === currency) return;
    el.textContent = currency;
    el.dataset.cosmeticLast = currency;
  }

  function convertBundlePrices(rate, currency, convertAmounts) {
    var selector = '#sternify-bundle .st_discounted-price, #sternify-bundle .st_compare-at-price, #sternify-bundle .st_unit-price, #sternify-variant-bundle .st_discounted-price, #sternify-variant-bundle .st_compare-at-price, #sternify-variant-bundle .st_unit-price';
    document.querySelectorAll(selector).forEach(function(el) {
      var numericNode = Array.from(el.childNodes).find(function(node) {
        return node.nodeType === Node.TEXT_NODE && !isNaN(parseMoney(node.textContent));
      });
      if (!numericNode) return;
      if (convertAmounts) convertTextNodeChild(el, rate, currency);
      var code = el.querySelector('[data-st-cosmetic-currency]');
      if (!code) {
        code = document.createElement('span');
        code.setAttribute('data-st-cosmetic-currency', '');
        code.setAttribute('data-cosmetic-code', '');
        code.style.marginInlineStart = '.25em';
        code.style.whiteSpace = 'nowrap';
        var unit = el.querySelector('.st_unit-label');
        el.insertBefore(code, unit || null);
      }
      updateCodeLabel(code, currency);
    });
  }
  function watchBundleBaseCurrency(currency) {
    var pending = false;
    var update = function() { convertBundlePrices(1, currency, false); };
    update();
    new MutationObserver(function() {
      if (pending) return;
      pending = true;
      setTimeout(function() { update(); pending = false; }, 50);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function convertAll(rate, currency) {
    convertBundlePrices(rate, currency, true);
    document.querySelectorAll('span.money').forEach(function (el) {
      convertLeaf(el, rate, currency, true);
    });
    document.querySelectorAll('[data-cosmetic-amount]').forEach(function (el) {
      convertLeaf(el, rate, currency, false);
    });
    document.querySelectorAll('[data-cosmetic-amount-node]').forEach(function (el) {
      convertTextNodeChild(el, rate, currency);
    });
    document.querySelectorAll('[data-cosmetic-code]').forEach(function (el) {
      updateCodeLabel(el, currency);
    });
  }

  async function init() {
    var currency = await detectCurrency();
    if (currency === STORE_CURRENCY) {
      watchBundleBaseCurrency(currency);
      return;
    }

    var usdRates = await getRates();
    if (!usdRates) return;

    var rate = crossRate(usdRates, currency);
    if (!rate) return;

    convertAll(rate, currency);

    // Some theme components (e.g. the product variant picker) re-render the price
    // text straight from server-side (raw store-currency) data shortly after load
    // or on variant switches, overwriting the converted value. A bounded set of
    // early re-scans catches those late overwrites even if the observer below
    // doesn't fire in time for them.
    [200, 500, 1000, 1800, 3000, 5000].forEach(function (delay) {
      setTimeout(function () {
        convertAll(rate, currency);
      }, delay);
    });

    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      // A plain timer (rather than requestAnimationFrame) keeps this debounce firing
      // even when the tab is backgrounded/not actively compositing frames.
      setTimeout(function () {
        convertAll(rate, currency);
        pending = false;
      }, 50);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
